module.exports = __webpack_public_path__ + "static/media/labs_images.0f6dbc03.jpg";